export const createEmptyContactDataPoint = () => ({
    value: '',
    type: '',
    feedback: null,
    isRevealed: false,
    isEdited: false,
    isManuallyAdded: false,
    doNotCall: null,
    isDncPhone: false,
    emailConfidence: null,
    id: null,
    status: null,
    shownDate: null,
    vendor: null,
    vendors: [],
});
